type Props = {
  totalQuantityLabel: string
  subtotalLabel: string
  totalLabel: string
  checkoutLabel: string
  checkoutBusyLabel: string
  checkoutDisabled: boolean
  checkoutBusy: boolean
  onCheckout: () => void
  itemCount: number
  subtotal: number
  formatCurrency: (value: number) => string
}

export const CartTotalsSection = ({
  totalQuantityLabel,
  subtotalLabel,
  totalLabel,
  checkoutLabel,
  checkoutBusyLabel,
  checkoutDisabled,
  checkoutBusy,
  onCheckout,
  itemCount,
  subtotal,
  formatCurrency,
}: Props) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <div className="space-y-2 text-sm text-slate-700">
      <div className="flex items-center justify-between">
        <span>{totalQuantityLabel}</span>
        <span className="font-semibold text-slate-900">{itemCount}</span>
      </div>
      <div className="flex items-center justify-between">
        <span>{subtotalLabel}</span>
        <span className="font-semibold text-slate-900">{formatCurrency(subtotal)}</span>
      </div>
      <div className="flex items-center justify-between border-t border-slate-200 pt-3 text-base">
        <span className="font-semibold text-slate-900">{totalLabel}</span>
        <span className="font-bold text-emerald-700">{formatCurrency(subtotal)}</span>
      </div>
    </div>
    <button
      type="button"
      className="mt-4 w-full rounded-lg bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300"
      onClick={onCheckout}
      disabled={checkoutDisabled}
    >
      {checkoutBusy ? checkoutBusyLabel : checkoutLabel}
    </button>
  </section>
)
